import { render } from "./Footer.vue?vue&type=template&id=1199c26c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=1199c26c&scoped=scoped&lang=css"

import exportComponent from "E:\\WorkCode\\HZY2026\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1199c26c"]])

export default __exports__